import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=73b87cf4&scoped=true&"
var script = {}
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=73b87cf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b87cf4",
  null
  
)

export default component.exports